export default __webpack_public_path__ + "static/media/Right Hand of Nergal.a3ecc2b7.jpg";